import { render, staticRenderFns } from "./VPie.vue?vue&type=template&id=2bae58b8&"
import script from "./VPie.vue?vue&type=script&lang=js&"
export * from "./VPie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports